module.exports = __webpack_public_path__ + "img/tarj2-5.bc8f7639.png";